/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';

export enum DocumentDetailsPictActionType {
    OPEN_DOCUMENT_CARD_PICT_PAGE = 'DocumentCardPict/ open page',
    EXIT_DOCUMENT_CARD_PICT_PAGE = 'DocumentCardPict/ exit page',

    FETCH_DOCUMENT_PICT_START = 'DocumentCardPict/ fetch document picture start',
    FETCH_DOCUMENT_PICT_SUCCESS = 'DocumentCardPict/ fetch document picture success',
    FETCH_DOCUMENT_PICT_ERROR = 'DocumentCardPict/ fetch document picture error',
}

export const openDocumentCardPictAction = () =>
    createAction(DocumentDetailsPictActionType.OPEN_DOCUMENT_CARD_PICT_PAGE);

export const exitDocumentCardPictAction = () =>
    createAction(DocumentDetailsPictActionType.EXIT_DOCUMENT_CARD_PICT_PAGE);

export const fetchDocumentPictStartAction = () => createAction(DocumentDetailsPictActionType.FETCH_DOCUMENT_PICT_START);

export const fetchDocumentPictSuccessAction = (payload: ArrayBuffer) =>
    createAction(DocumentDetailsPictActionType.FETCH_DOCUMENT_PICT_SUCCESS, payload);

export const fetchDocumentPictErrorAction = (notification: Notification) =>
    createAction(DocumentDetailsPictActionType.FETCH_DOCUMENT_PICT_ERROR, { notification });

export type DocumentDetailsPictAction =
    | ReturnType<typeof openDocumentCardPictAction>
    | ReturnType<typeof exitDocumentCardPictAction>
    | ReturnType<typeof fetchDocumentPictStartAction>
    | ReturnType<typeof fetchDocumentPictSuccessAction>
    | ReturnType<typeof fetchDocumentPictErrorAction>;
